<template>
    <div class="home">
        <section id="hero" class="md:h-88vh">
            <div class="slider h-full">
                <div class="slide h-full p-6 lg:px-24 md:py-8 flex flex-col justify-center text-left bg-cover"
                     :style="{backgroundImage: 'url(' + require('@/assets/img/hero-background-darker.jpg') + ')'}">
                    <div class="md:w-8/12">
                            <h1 class="text-4xl font-bold leading-tight text-white mb-6 animated bounceInLeft delay-1s">Você está criando algo para
                                melhorar a
                                <br>vida
                                das
                                pessoas?</h1>
                            <h3 class="text-xl font-bold text-accent mb-4 animated bounceInLeft delay-2s">Nós queremos fazer parte disso!</h3>
                            <p class="text-white text-xl animated bounceInLeft delay-3s">Acesse o catálogo de APIs da PRODAM. As APIs são conectores
                                que
                                propiciam
                                o
                                compatilhamento de informações governamentais em tempo real. Conheça as APIs disponíveis
                                e
                                descubra
                                como
                                elas podem simplificar suas integrações.</p>
                            <button class="mt-8 bg-accent text-gray-900 font-bold py-4 px-6 shadow hover:bg-accent-lighter animated bounceInLeft delay-4s">
							<a target="_blank" href="https://console.prodam.am.gov.br"> CONHEÇA NOSSAS APIs </a>
                            </button>
                        </div>
                </div>
            </div>
        </section>
        <section id="apis" class="hidden">
            <h1 class="text-center text-4xl font-bold leading-tight mt-10 mb-3">Galeria de APIs</h1>
            <h2 class="text-center text-2xl font-bold leading-tight text-accent">Por enquanto estamos disponibilizando apenas alguns serviços,
                <br>mas com a sua ajuda outros virão</h2>

        </section>
        <section id="features" class="bg-feature overflow-hidden">
            <h1 class="text-center text-4xl font-bold leading-tight my-6 md:my-10">Plataforma de Interoperabilidade <br>da
                PRODAM</h1>
            <div class="feature flex lg:flex-row flex-col justify-between">
                <div class="feature-desc flex-shrink-0 md:py-6 px-10 lg:pl-24 animated bounceInLeft delay-2s" v-if="visible">
                    <h3 class="text-xl md:text-3xl text-center md:text-left font-bold mb-4 leading-tight">Uma infraestrutura tecnológica que propicia:</h3>
                    <ul class="list-disc pl-8 md:pl-12">
                        <li class="mb-3 text-xl">A integração de serviços públicos;</li>
                        <li class="mb-3 text-xl">O compartilhamento de informações e medição de aplicações;</li>
                        <li class="mb-3 text-xl">A governança dos ativos e processos de integração;</li>
                        <li class="mb-3 text-xl">Modelo simplificado de consumo de APIs.</li>
                    </ul>
                </div>
                <div class="feature-img animated fadeInRight delay-1s" v-if="visible">
                    <img src="@/assets/img/pc.png" alt="pc"/>
                </div>
            </div>
        </section>
        <div id="fot" class="h-1"></div>
    </div>
</template>

<script>
    import inViewport from 'in-viewport';
    // @ is an alias to /src
    export default {
        name: 'Home',
        data() {
            return {
                visible: false
            }
        },
        mounted() {
            inViewport(document.getElementById('fot'), () => {
                this.visible = true;
            });
        }
    }
</script>
